import React, { AriaRole } from "react";
import { useRouter } from "next/router";
import { LinkProps } from "next/link";
import { resolveHref } from "next/dist/client/resolve-href";
import { clientLogger } from "@/utils/clientLogger";
import { useFeatureFlags } from "@/flags/flags";

type Props = LinkProps & {
  className?: string;
  role?: AriaRole;
  children: React.ReactNode;
};

export function LinkWithoutPrefetch(props: Props) {
  const router = useRouter();

  const { isRequestAnimationFrameOn } = useFeatureFlags();

  const { children, href, onClick, shallow, scroll, ...anchorProps } = props;
  const url = resolveHref(router, href);

  async function handleClick(event: React.MouseEvent<HTMLAnchorElement>) {
    event.preventDefault();

    const navigate = () => {
      try {
        onClick?.(event);
        router.push(href, undefined, { shallow, scroll });
      } catch (error) {
        clientLogger.error({ error }, `Failed to navigate to ${url}`);
      }
    };

    if (isRequestAnimationFrameOn?.value) {
      requestAnimationFrame(navigate);
    } else {
      navigate();
    }
  }

  return (
    <a {...anchorProps} href={url} onClick={handleClick}>
      {children}
    </a>
  );
}
